__turbopack_context__.v({
  "className": "nunito_5a17840d-module__dswY_G__className",
});
